import posthog from "posthog-js"

export function isAnalyticsEnabled(): boolean {
  return Boolean(process.env.GATSBY_POSTHOG_KEY || "phc_AGuqGBfc85fuXm6iRcJ9QvcvXiWtky6quDHGNQLSBBUr")
}

/** Client-side product events (PostHog project key must be set at build time). */
export function capture(event: string, properties?: Record<string, unknown>): void {
  if (!isAnalyticsEnabled()) return
  posthog.capture(event, properties)
}
